"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var alert_1 = require("./alert");
var alert_config_1 = require("./alert-config");
var alert_2 = require("./alert");
exports.NgbAlert = alert_2.NgbAlert;
var alert_config_2 = require("./alert-config");
exports.NgbAlertConfig = alert_config_2.NgbAlertConfig;
var NgbAlertModule = /** @class */ (function () {
    function NgbAlertModule() {
    }
    NgbAlertModule_1 = NgbAlertModule;
    NgbAlertModule.forRoot = function () { return { ngModule: NgbAlertModule_1, providers: [alert_config_1.NgbAlertConfig] }; };
    NgbAlertModule = NgbAlertModule_1 = __decorate([
        core_1.NgModule({ declarations: [alert_1.NgbAlert], exports: [alert_1.NgbAlert], imports: [common_1.CommonModule], entryComponents: [alert_1.NgbAlert] })
    ], NgbAlertModule);
    return NgbAlertModule;
    var NgbAlertModule_1;
}());
exports.NgbAlertModule = NgbAlertModule;
//# sourceMappingURL=alert.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/alert/alert.module.js
// module id = 31
// module chunks = 0